import { FC, useMemo } from 'react'
import { useTranslation } from 'next-i18next/pages'
import { UseFormRegister, UseFormGetValues, FieldErrors } from 'react-hook-form'
import { WishlistManager } from '../../Hooks/WishlistActionTypes'
import { WishlistProductGrid } from '../../WishlistItems'

import {
    Wishlist,
    WishlistItemInterface,
    ConfigurableWishlistItem,
    WishlistItemUpdateInput
} from '@pylot-data/pylotschema'
import s from '@pagestyles/Wishlist.module.scss'

export type wishlist = {
    wishlist: Wishlist
    wishlistManager: WishlistManager
    register: UseFormRegister<Array<WishlistItemUpdateInput>>
    getValues?: UseFormGetValues<Array<WishlistItemUpdateInput>>
    errors: FieldErrors<Array<WishlistItemUpdateInput>>
}

export const WishlistItems: FC<wishlist> = ({ wishlist, wishlistManager }) => {
    const { t } = useTranslation(['wishlist'])

    const items = useMemo(() => {
        return wishlist?.items_v2?.items?.map((item, key) => (
            <div className={s['wishlist-product-grid']} key={key}>
                <WishlistProductGrid
                    item={
                        item as WishlistItemInterface & ConfigurableWishlistItem
                    }
                    wishlistManager={wishlistManager}
                    wishlistId={wishlist?.id}
                />
            </div>
        ))
    }, [wishlist, wishlistManager])

    if (!wishlist?.items_v2?.items?.length) {
        return (
            <div className={s['wishlist-no-items']}>
                {t('wishlist|You have no items in your wish list.')}
            </div>
        )
    }

    return <div className={s['wishlist-items-container']}>{items}</div>
}
